import { Pipe, PipeTransform } from '@angular/core';

import { Numbers } from '../utils/numbers';

@Pipe({ name: 'transactionAmount' })
export class TransactionAmountPipe implements PipeTransform {
  public static formatAmount(value: number): string {
    if (value === Number.MAX_SAFE_INTEGER) {
      return 'Full available balance';
    }

    const currency = Numbers.formatCurrency(value);
    if (value < 0) {
      return currency.slice(0, 1) + ' ' + currency.slice(1);
    } else if (value === 0) {
      return `- ${currency}`;
    }
    return `+ ${currency}`;
  }

  public transform(value: number): string {
    return TransactionAmountPipe.formatAmount(value);
  }
}
